import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2925e03e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-grow-1 flex-row" }
const _hoisted_2 = { class: "d-flex justify-content-center align-items-center p-5" }


import Spinner from "@/components/Spinner.vue"
import GalleryGridColumn from "@/components/gallery/GalleryGridColumn.vue";
import {columnAmount} from "@/stores/gallery";


export default /*#__PURE__*/_defineComponent({
  props: {
  selectionMode: {
    type: Boolean,
    required: true
  },
  selection: {
    type: Array,
    required: true,
    default() {
      return []
    }
  },
  showBottomSpinner: {
    type: Boolean,
  }
},
  emits: ["imageSelected", "imageUnselected", "tooManyImagesSelected"],
  setup(__props, { emit }: { emit: ({
  (e: 'imageSelected', val: number):void
  (e: 'imageUnselected', val:number):void
  (e: 'tooManyImagesSelected'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "container-container-gallery",
      class: _normalizeClass(["d-flex flex-column h-100", {'shrink':!__props.selectionMode}])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columnAmount), (i) => {
          return (_openBlock(), _createBlock(GalleryGridColumn, {
            key: i,
            idx: i-1,
            selectionMode: __props.selectionMode,
            selection: __props.selection,
            onImageSelected: _cache[0] || (_cache[0] = (val) => emit('imageSelected', val)),
            onImageUnselected: _cache[1] || (_cache[1] = (val) => emit('imageUnselected', val)),
            onTooManyImagesSelected: _cache[2] || (_cache[2] = () => emit('tooManyImagesSelected'))
          }, null, 8, ["idx", "selectionMode", "selection"]))
        }), 128))
      ])
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      (__props.showBottomSpinner)
        ? (_openBlock(), _createBlock(Spinner, {
            key: 0,
            style: {"width":"5rem","height":"5rem"}
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})